import React, { useEffect } from "react";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DashboardRoutes from "./routes/DashboardRoutes";
import MainRoutes from "./routes/MainRoutes";
import ScrollToTop from "./MainWebsite/Components/ScrollToTop/ScrollToTop";

function App() {
  useEffect(() => {
    const videos = document.querySelectorAll("video");

    videos.forEach((video) => {
      if (video.readyState >= 2) {
        video.currentTime = 0.001;
      } else {
        video.addEventListener("loadeddata", function setTime() {
          video.currentTime = 0.001;
          video.removeEventListener("loadeddata", setTime); // Clean up
        });
      }
    });
  }, []);
  return (
    // <BrowserRouter basename="/BadIdea">
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/*" element={<MainRoutes />} />
        <Route path="/dashboard/*" element={<DashboardRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
